













import { Component, Prop, Vue } from "vue-property-decorator";

export interface Room {
  id: string;
  name: string;
  status: string
  group: {
    id: string;
  };
}

@Component
export default class RoomListsComponent extends Vue {
  @Prop({ type: String, required: true }) buildingId!: string;
  @Prop({ type: String, required: true }) buildingGroupId!: string;
  @Prop({ type: Array, required: true }) rooms!: Room[];
}
